export default __webpack_public_path__ + "assets/fonts/7a3c08f639e5658ebaec62d677e55fc7.woff2";